import FinancingRequestStudent from "../FinancingRequestStudent";

export default interface PersonalTransportOption {
  readonly mileageFromHomeToSchool?: number | null;
  readonly passengers?: FinancingRequestStudent[];
}

export const PersonalTransportOptionInital: PersonalTransportOption = {
  mileageFromHomeToSchool: null,
  passengers: new Array<FinancingRequestStudent>()
};
